import {
    BASKET_SCOPE_DEV,
    BASKET_SCOPE_PROD,
    BASKET_SCOPE_QA,
    DEFAULT_POLICY,
    OAuthTokenScopes,
    WZ_SCOPE_DEV,
    WZ_SCOPE_PROD,
    WZ_SCOPE_QA,
} from '@os-components';

export const authDev: OAuthTokenScopes = {
    clientId: '3b4f93b9-16cd-42ae-a88c-4ef9df57e8b7',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_DEV, WZ_SCOPE_DEV],
};
export const authQa: OAuthTokenScopes = {
    clientId: 'cce40e54-f141-4907-95ca-af7b35ab9c46',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_QA, WZ_SCOPE_QA],
};

// TODO Ändern mit richtige wenn es gibt prod auth scope
export const authProd: OAuthTokenScopes = {
    clientId: 'f3dad7e4-7aa7-4167-b074-351252b21e58',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_PROD, WZ_SCOPE_PROD],
};

export const href = '/blog/';
